import React, { Component } from 'react';
import { FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Moment from 'moment';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import * as actions from '../../store/actions';
import { STATUS_STEPS, getAllStatusSteps } from '../../constants/statusSteps';

class StatusSteps extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            editingStep: null,
            employees: [
                { _id: '1', firstName: 'Hadia', lastName: 'Amor' },
                { _id: '2', firstName: 'Zhanyl', lastName: 'Borbushova' },
                { _id: '3', firstName: 'Houria', lastName: 'El Ouai' },
                { _id: '4', firstName: 'Francesco', lastName: 'Errichiello' },
                { _id: '5', firstName: 'Ruth', lastName: 'Mandengué' },
                { _id: '6', firstName: 'Mürüvvet', lastName: 'Sanal' },
                { _id: '7', firstName: 'Luca', lastName: 'Toto' },
                { _id: '8', firstName: 'Incoronata', lastName: 'Toto' },
                { _id: '9', firstName: '⁠⁠Igor', lastName: 'Fernandes De Souza' },
            ],
            selectedEmployee: '',
            comment: '',
            timestamp: new Date(),
            expandedComments: {}
        };
    }


    // Define all possible status steps
    getStatusSteps = () => {
        const { t } = this.props;
        const allSteps = getAllStatusSteps().map(step => ({
            id: step.id,
            key: step.key,
            dbKey: step.dbKey,
            label: t(`statusSteps.${step.key.toLowerCase()}`)
        }));

        // Filter out "difference paid" if "difference to pay" doesn't have a comment
        return allSteps.filter(step => {
            if (step.key === 'DIFFERENCE_PAID') {
                const differenceToPayStep = this.getStatusStepData(STATUS_STEPS.DIFFERENCE_TO_PAY.id);
                return differenceToPayStep.comment && differenceToPayStep.comment.trim() !== '';
            }
            return true;
        });
    };

    getStatusStepData = (statusId) => {
        const order = this.props.order || {};
        const statusSteps = order.statusSteps || [];
        const statusStep = STATUS_STEPS[Object.keys(STATUS_STEPS).find(key => STATUS_STEPS[key].id === statusId)];
        const dbKey = statusStep ? statusStep.dbKey : null;
        
        return statusSteps.find(step => step.status === dbKey) || {
            status: dbKey,
            completed: false,
            timestamp: null,
            employeeName: null,
            comment: null
        };
    };

    // Find current user in employees list and return their ID
    getCurrentUserEmployeeId = () => {
        const { currentUser, userName } = this.props;
        const { employees } = this.state;
        
        // Check if we have user info and employees are available
        if ((!currentUser && !userName) || !employees || employees.length === 0) {
            return null;
        }

        // If we have a full user object, match by firstName and lastName
        if (currentUser && currentUser.firstName && currentUser.lastName) {
            const matchingEmployee = employees.find(employee => 
                employee.firstName === currentUser.firstName && 
                employee.lastName === currentUser.lastName
            );
            return matchingEmployee ? matchingEmployee._id : null;
        }

        // If we only have userName (string like "John Doe"), parse it and match
        if (userName) {
            const nameParts = userName.trim().split(' ');
            if (nameParts.length >= 2) {
                const firstName = nameParts[0];
                const lastName = nameParts.slice(1).join(' '); // Handle multiple last names
                
                const matchingEmployee = employees.find(employee => 
                    employee.firstName === firstName && 
                    employee.lastName === lastName
                );
                return matchingEmployee ? matchingEmployee._id : null;
            }
        }

        return null;
    };

    handleCheckboxChange = (statusId) => {
        const { order, token } = this.props;
        
        if (!order || !order._id) {
            console.error('Order not loaded or missing ID');
            return;
        }
        
        const stepData = this.getStatusStepData(statusId);
        const statusStep = STATUS_STEPS[Object.keys(STATUS_STEPS).find(key => STATUS_STEPS[key].id === statusId)];
        const dbKey = statusStep ? statusStep.dbKey : null;
        
        if (stepData.completed) {
            // If unchecking, we need to remove the step
            this.props.updateStatusStep(token, order._id, {
                status: dbKey,
                completed: false,
                action: 'remove'
            });
        } else {
            // If checking, open modal to get employee and comment
            const currentUserEmployeeId = this.getCurrentUserEmployeeId();
            this.setState({
                modalOpen: true,
                editingStep: statusId,
                selectedEmployee: currentUserEmployeeId || '',
                comment: '',
                timestamp: new Date()
            });
        }
    };

    handleModalSave = () => {
        const { editingStep, selectedEmployee, comment, timestamp } = this.state;
        const { order, token, t } = this.props;
        
        if (!order || !order._id) {
            console.error('Order not loaded or missing ID');
            return;
        }
        
        if (!selectedEmployee) {
            alert(t('statusSteps.selectEmployeeError'));
            return;
        }

        const employee = this.state.employees.find(emp => emp._id === selectedEmployee);
        const employeeName = employee ? `${employee.firstName} ${employee.lastName}` : 'Unknown';
        
        const statusStep = STATUS_STEPS[Object.keys(STATUS_STEPS).find(key => STATUS_STEPS[key].id === editingStep)];
        const dbKey = statusStep ? statusStep.dbKey : null;
        
        this.props.updateStatusStep(token, order._id, {
            status: dbKey,
            completed: true,
            timestamp: timestamp,
            employeeName: employeeName,
            comment: comment,
            action: 'add'
        });

        this.setState({
            modalOpen: false,
            editingStep: null,
            selectedEmployee: '',
            comment: '',
            timestamp: new Date()
        });
    };

    handleEditStatus = (statusId) => {
        const stepData = this.getStatusStepData(statusId);
        
        // Find the employee ID that matches the current employee name
        const currentEmployee = this.state.employees.find(emp => 
            `${emp.firstName} ${emp.lastName}` === stepData.employeeName
        );
        
        // If no current employee found, try to use the current user as default
        const currentUserEmployeeId = this.getCurrentUserEmployeeId();
        const defaultEmployeeId = currentEmployee ? currentEmployee._id : (currentUserEmployeeId || '');
        
        this.setState({
            modalOpen: true,
            editingStep: statusId,
            selectedEmployee: defaultEmployeeId,
            comment: stepData.comment || '',
            timestamp: stepData.timestamp ? new Date(stepData.timestamp) : new Date()
        });
    };

    handleModalCancel = () => {
        this.setState({
            modalOpen: false,
            editingStep: null,
            selectedEmployee: '',
            comment: '',
            timestamp: new Date()
        });
    };

    toggleCommentExpansion = (statusName) => {
        this.setState(prevState => ({
            expandedComments: {
                ...prevState.expandedComments,
                [statusName]: !prevState.expandedComments[statusName]
            }
        }));
    };

    renderStatusStep = (statusStep, index) => {
        const { t } = this.props;
        const stepData = this.getStatusStepData(statusStep.id);
        const isCompleted = stepData.completed;
        const isCommentExpanded = this.state.expandedComments[statusStep.id];
        const statusSteps = this.getStatusSteps();
        const isLastStep = index === statusSteps.length - 1;
        
        return (
            <div key={statusStep.key} className="status-step-row mb-4 position-relative">
                <div className="d-flex align-items-start">
                    {/* Timeline line and checkbox */}
                    <div className="d-flex flex-column align-items-center mr-3">
                        {/* Bigger checkbox */}
                        <div className="position-relative">
                            <FormGroup check className="mb-0">
                                <Input
                                    type="checkbox"
                                    checked={isCompleted}
                                    onChange={() => this.handleCheckboxChange(statusStep.id)}
                                    disabled={this.props.loadingStatusStep}
                                    style={{ transform: 'scale(2)', transformOrigin: 'left' }}
                                />
                            </FormGroup>
                        </div>
                        
                        {/* Vertical timeline line */}
                        {!isLastStep && (
                            <div 
                                className="position-absolute"
                                style={{
                                    top: '37px',
                                    left: '13px',
                                    transform: 'translateX(-50%)',
                                    width: '2px',
                                    height: 'calc(100% - 25px)',
                                    backgroundColor: '#212529',
                                    opacity: 0.5,
                                    zIndex: 1
                                }}
                            />
                        )}
                    </div>
                    
                    {/* Content area */}
                    <div cassName="flex-grow-1">
                        {/* State name on same line as checkbox */}
                        <div className="mb-0 d-flex align-items-center">
                            <span 
                                className={`status-name bold`} 
                                style={{ 
                                    fontSize: '1.1rem', 
                                    fontWeight: '500', 
                                    letterSpacing: '0.01em',
                                    cursor: 'pointer'
                                }}
                                onClick={() => this.handleEditStatus(statusStep.id)}
                                title={t('statusSteps.editStatus')}
                            >
                                {statusStep.label}
                            </span>
                            {/* Edit button */}
                            {isCompleted && (
                                <div className="ml-1">
                                    <Button
                                        color="link"
                                        size="sm"
                                        onClick={() => this.handleEditStatus(statusStep.id)}
                                        className="p-0 d-flex align-items-center justify-content-center"
                                        style={{ color: '#212529' }}
                                        title={t('statusSteps.editStatus')}
                                    >
                                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                                    </Button>
                                </div>
                            )}
                        </div>
                        
                        {/* Date and time on new line */}
                        {isCompleted && (
                            <div className="mb-0">
                                <small className="text-muted">
                                    {Moment(stepData.timestamp).format('DD.MM.YYYY – HH:mm')}
                                </small>
                            </div>
                        )}
                        
                        {/* Employee name on new line */}
                        {isCompleted && (
                            <div className="mb-0">
                                <small className="text-muted">
                                    {stepData.employeeName || t('statusSteps.unknown')}
                                </small>
                            </div>
                        )}
                        
                        {/* Comment with ellipsis functionality */}
                        {isCompleted && stepData.comment && (
                            <div className="mb-0">
                                <small 
                                    className="text-muted"
                                    style={{ 
                                        cursor: 'pointer',
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-word'
                                    }}
                                    onClick={() => this.toggleCommentExpansion(statusStep.id)}
                                >
                                    {isCommentExpanded ? stepData.comment : (
                                        stepData.comment.length > 50 ? 
                                        `${stepData.comment.substring(0, 50)}...` : 
                                        stepData.comment
                                    )}
                                </small>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { modalOpen, editingStep, selectedEmployee, comment, timestamp } = this.state;
        const { order, t } = this.props;

        // Don't render if order is not loaded yet
        if (!order) {
            return (
                <div class="status-steps mt-2">
                    <div>
                        <h5 className="mb-3">{t('statusSteps.title')}</h5>
                    </div>
                    <div>
                    <p className="text-muted mb-0">{t('statusSteps.loading')}</p>
                    </div>
                </div>
            );
        }

        return (
            <div class="status-steps mt-2">
                <div>
                    <h5 className="mb-3">{t('statusSteps.title')}</h5>
                </div>
                <div>
                    {this.getStatusSteps().map((statusStep, index) => this.renderStatusStep(statusStep, index))}
                </div>

                {/* Modal for adding status step */}
                <Modal isOpen={modalOpen} toggle={this.handleModalCancel} className="status-steps-modal">
                    <ModalHeader toggle={this.handleModalCancel}>
                        {this.getStatusStepData(editingStep).completed ? t('statusSteps.editStatus') : t('statusSteps.completeStatus')}: {editingStep ? this.getStatusSteps().find(s => s.id === editingStep)?.label || editingStep : ''}
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label for="employeeSelect">{t('statusSteps.employee')} *</Label>
                            <Input
                                type="select"
                                id="employeeSelect"
                                value={selectedEmployee}
                                onChange={(e) => this.setState({ selectedEmployee: e.target.value })}
                            >
                                <option value="">{t('statusSteps.selectEmployee')}</option>
                                {this.state.employees && this.state.employees.length > 0 ? (
                                    this.state.employees.map(employee => {
                                        const currentUserEmployeeId = this.getCurrentUserEmployeeId();
                                        const isCurrentUser = employee._id === currentUserEmployeeId;
                                        return (
                                            <option key={employee._id} value={employee._id}>
                                                {employee.firstName} {employee.lastName}{isCurrentUser ? ` ${t('statusSteps.you')}` : ''}
                                            </option>
                                        );
                                    })
                                ) : (
                                    <option value="" disabled>{t('statusSteps.loadingEmployees')}</option>
                                )}
                            </Input>
                        </FormGroup>
                        
                        <FormGroup>
                            <Label for="timestamp">{t('statusSteps.dateTime')}</Label>
                            <Input
                                type="datetime-local"
                                id="timestamp"
                                value={Moment(timestamp).format('YYYY-MM-DDTHH:mm')}
                                onChange={(e) => this.setState({ timestamp: new Date(e.target.value) })}
                            />
                        </FormGroup>
                        
                        <FormGroup>
                            <Label for="comment">{t('statusSteps.comment')}</Label>
                            <Input
                                type="textarea"
                                id="comment"
                                value={comment}
                                onChange={(e) => this.setState({ comment: e.target.value })}
                                rows="3"
                                placeholder={t('statusSteps.commentPlaceholder')}
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.handleModalCancel}>
                            {t('statusSteps.cancel')}
                        </Button>
                        <Button color="primary" onClick={this.handleModalSave}>
                            {t('statusSteps.save')}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateStatusStep: (token, orderId, stepData) => dispatch(actions.updateStatusStep(token, orderId, stepData))
    };
};

const mapStateToProps = state => ({
    loadingStatusStep: state.orders.loadingStatusStep || false,
    token: state.auth.token,
    currentUser: state.users.user || null,
    userName: state.auth.userName || null
});

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(StatusSteps));
